import React from 'react';
import { Settings as SettingsIcon } from 'lucide-react';

export default function SystemSettings() {
  return (
    <div className="p-6">
      <div className="flex items-center mb-6">
        <SettingsIcon className="h-6 w-6 text-gray-400 mr-2" />
        <h2 className="text-lg font-medium text-gray-900">System Settings</h2>
      </div>

      <div className="space-y-6">
        <div className="bg-white rounded-lg border border-gray-200 p-6">
          <h3 className="text-lg font-medium text-gray-900 mb-4">General Settings</h3>
          <div className="space-y-4">
            <div>
              <label className="block text-sm font-medium text-gray-700">
                System Name
              </label>
              <input
                type="text"
                defaultValue="ARAC Lease Management System"
                className="mt-1 block w-full rounded-md border border-gray-300 px-3 py-2"
              />
            </div>
            <div>
              <label className="block text-sm font-medium text-gray-700">
                Default Timezone
              </label>
              <select
                defaultValue="Australia/Darwin"
                className="mt-1 block w-full rounded-md border border-gray-300 px-3 py-2"
              >
                <option value="Australia/Darwin">Darwin (ACST)</option>
                <option value="Australia/Adelaide">Adelaide (ACST)</option>
                <option value="Australia/Sydney">Sydney (AEST)</option>
              </select>
            </div>
          </div>
        </div>

        <div className="bg-white rounded-lg border border-gray-200 p-6">
          <h3 className="text-lg font-medium text-gray-900 mb-4">Email Settings</h3>
          <div className="space-y-4">
            <div>
              <label className="block text-sm font-medium text-gray-700">
                SMTP Server
              </label>
              <input
                type="text"
                defaultValue="smtp.aracleasing.com.au"
                className="mt-1 block w-full rounded-md border border-gray-300 px-3 py-2"
              />
            </div>
            <div>
              <label className="block text-sm font-medium text-gray-700">
                SMTP Port
              </label>
              <input
                type="number"
                defaultValue="587"
                className="mt-1 block w-full rounded-md border border-gray-300 px-3 py-2"
              />
            </div>
          </div>
        </div>

        <div className="bg-white rounded-lg border border-gray-200 p-6">
          <h3 className="text-lg font-medium text-gray-900 mb-4">Security Settings</h3>
          <div className="space-y-4">
            <div>
              <label className="block text-sm font-medium text-gray-700">
                Session Timeout (minutes)
              </label>
              <input
                type="number"
                defaultValue="30"
                className="mt-1 block w-full rounded-md border border-gray-300 px-3 py-2"
              />
            </div>
            <div>
              <label className="block text-sm font-medium text-gray-700">
                Password Policy
              </label>
              <div className="mt-2 space-y-2">
                <label className="flex items-center">
                  <input
                    type="checkbox"
                    defaultChecked
                    className="h-4 w-4 text-primary border-gray-300 rounded"
                  />
                  <span className="ml-2 text-sm text-gray-600">
                    Require uppercase letters
                  </span>
                </label>
                <label className="flex items-center">
                  <input
                    type="checkbox"
                    defaultChecked
                    className="h-4 w-4 text-primary border-gray-300 rounded"
                  />
                  <span className="ml-2 text-sm text-gray-600">
                    Require numbers
                  </span>
                </label>
                <label className="flex items-center">
                  <input
                    type="checkbox"
                    defaultChecked
                    className="h-4 w-4 text-primary border-gray-300 rounded"
                  />
                  <span className="ml-2 text-sm text-gray-600">
                    Require special characters
                  </span>
                </label>
              </div>
            </div>
          </div>
        </div>

        <div className="flex justify-end">
          <button
            type="button"
            className="px-4 py-2 bg-primary text-white rounded-md text-sm font-medium hover:bg-primary-dark"
          >
            Save Changes
          </button>
        </div>
      </div>
    </div>
  );
}